module.exports = __webpack_public_path__ + "js/components/Explorer/images/folder-closed-2f93bf91dcf519fe4b8a63dcf46c782e.ico";